import { IProduct } from '../../models';
// import ProductPlusSection from './ProductPlusSection';
import ProductTechnologies from './ProductTechnologies';
import ProductOverviews from './ProductOverviews';
import ProductRelated from './ProductRelated';
import CategoryImage from '../CategoryImage';
import { useTranslation } from 'react-i18next';
// import ProductCommunity from './ProductCommunity';
// import ProductReviews from './ProductReviews';

export default function ProductPage({
  product,
  shippmentAndReturnInfoText,
  loading = false
}: {
  product: IProduct;
  shippmentAndReturnInfoText: string;
  loading: boolean;
}) {
  const {
    extreme,
    banner = false,
    banner_footer = false,
    related = false
  } = product;
  const { t } = useTranslation();
  return (
    <>
      <div>
        <ProductOverviews
          product={product}
          loadingProduct={loading}
          shippmentAndReturnInfoText={shippmentAndReturnInfoText}
        />
        {banner && banner.image && banner.text_align === 'right' && (
          <CategoryImage
            textRight
            title={banner.text?.title || ''}
            description={banner.text?.text || ''}
            image={banner.image}
          />
        )}
        {banner && banner.image && banner.text_align === 'left' && (
          <CategoryImage
            textLeft
            title={banner.text?.title || ''}
            description={banner.text?.text || ''}
            image={banner.image}
          />
        )}
        {banner && banner.image && banner.text_align === 'center' && (
          <CategoryImage
            title={banner.text?.title || ''}
            description={banner.text?.text || ''}
            image={banner.image}
          />
        )}
        {related && related.length > 0 && (
          <div className="py-16 sm:py-120 px-4 sm:px-12 bg-grey-custom">
            <ProductRelated product={product} />
          </div>
        )}
        {/* <ProductPlusSection product={product} /> */}
        {/* <ProductTechnologies product={product} /> */}
        {/* <ProductReviews product={product} /> */}

        {/* <div className="bg-grey-custom py-120 ">
          <ProductCommunity />
        </div> */}

        {/* <div className="bg-lightgrey py-120"> */}

        {banner_footer && (
          <CategoryImage
            title={banner_footer.title ? banner_footer.title : ''}
            description={banner_footer.text ? banner_footer.text : ''}
            image={banner_footer.image ? banner_footer.image : ''}
            fullHeight
            extreme={extreme}
          />
        )}
      </div>
    </>
  );
}
